import { useTranslation } from "react-i18next";

export default function SKGKeurmerk() {
  const { t } = useTranslation("slot-cilinder-vervangen");

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[800px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("skg.h2")}
        </h2>
        <div className="flex flex-col gap-6 md:gap-8">
          <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
            {t("skg.p1")}
          </p>
          <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
            {t("skg.p2")}
          </p>
        </div>
      </div>
    </section>
  );
}